import { useEffect, useState } from 'react'
import { useNavigate, useSearchParams } from 'react-router-dom'
import PageHeader from '../../admin/components/PageHeader'
import apiClient from '../../global/utils/apiClient'
import RoundHistoryTable from '../../scoring/components/RoundHistoryTable'
import '../../styles/admin.css'

function GolferDetailView() {
  const [searchParams] = useSearchParams()
  const golferId = searchParams.get('golferId')
  const [rounds, setRounds] = useState([])
  const [golferName, setGolferName] = useState('')
  const navigate = useNavigate()

  useEffect(() => {
    window.scrollTo(0, 0)
    if (golferId) {
      // Fetch golfer details
      apiClient.get(`/gskapi/golfers/find/${golferId}`)
        .then((response) => {
          setGolferName(response.data.golferName)
        })
        .catch((error) => {
          console.error('Error fetching golfer data:', error)
        })

      // Fetch rounds for the golfer
      apiClient.get(`/gskapi/rounds/golfer/${golferId}`)
        .then((response) => {
          // Sort by date descending
          const sorted = response.data.sort((a, b) => new Date(b.roundDate) - new Date(a.roundDate))
          setRounds(sorted)
        })
        .catch((error) => {
          console.error('Error fetching round data:', error)
        })
    }
  }, [golferId, navigate])

  return (
    <>
      <PageHeader backTo={-1} pageName={golferName ? `${golferName} - Rounds` : 'Golfer Rounds'} />
      <div style={{ maxWidth: '800px', margin: '0 auto', padding: '10px' }}>
        <RoundHistoryTable rounds={rounds} />
      </div>
    </>
  )
}

export default GolferDetailView
